<div class="card-header detail-view-header">
  <div class="row">
    <div class="col-11">
      {{ detailFormDataModel | detailViewTitle | async }}
    </div>
    <div class="col-1 text-right">
      <button (click)="closeClick()" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>
